import "core-js/modules/es6.function.name";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.item.children.length < 1 ? _c('MenuItem', {
    attrs: {
      "name": _vm.item.name,
      "to": _vm.item.path
    }
  }, [_vm._v(_vm._s(_vm.item.meta.name))]) : _c('Submenu', {
    attrs: {
      "name": _vm.item.name
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v("\n        " + _vm._s(_vm.item.meta.name) + "\n    ")]), _vm._l(_vm.item.children, function (sub, i) {
    return _c('SysMenuItem', {
      key: i,
      attrs: {
        "item": sub
      }
    });
  })], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };